import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

//import { provideOAuthClient } from 'angular-oauth2-oidc'; //npm i angular-oauth2-oidc --save
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideHttpClient(),

		DatePipe //For tzDatePipe
		// provideOAuthClient(),
	]
};
